var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "servcReqVoucherForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.servcReqVoucher }
        },
        [
          _c("div", { staticClass: "block-container" }, [
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("零售商信息")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [_vm._v("零售商")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcReqVoucher.buyerName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcReqVoucher, "buyerName", $$v)
                        },
                        expression: "servcReqVoucher.buyerName"
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      on: { click: _vm.selectRetailer }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("机构信息")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-single mt20 mb20",
                staticStyle: { overflow: "visible" }
              },
              [
                _c("div", { staticClass: "title required" }, [
                  _vm._v("机构名称")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "buyerShopName" } },
                        [
                          _c("el-input", {
                            staticClass: "width-1-5x bottom-line",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.servcReqVoucher.buyerShopName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.servcReqVoucher,
                                  "buyerShopName",
                                  $$v
                                )
                              },
                              expression: "servcReqVoucher.buyerShopName"
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                            on: { click: _vm.selectRetailerShop }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("联系人")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcReqVoucher.contactName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcReqVoucher, "contactName", $$v)
                        },
                        expression: "servcReqVoucher.contactName"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("地址信息")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("地址信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "480px" } },
                  [
                    _c("swb-region", {
                      ref: "swb_region",
                      attrs: { item: _vm.addressRegion }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title " }, [_vm._v("地址门牌号")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "480px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-3x",
                      model: {
                        value: _vm.servcReqVoucher.buyerShopStreet,
                        callback: function($$v) {
                          _vm.$set(_vm.servcReqVoucher, "buyerShopStreet", $$v)
                        },
                        expression: "servcReqVoucher.buyerShopStreet"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("联系电话")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "480px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-3x",
                      model: {
                        value: _vm.servcReqVoucher.buyerShopContactTel,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.servcReqVoucher,
                            "buyerShopContactTel",
                            $$v
                          )
                        },
                        expression: "servcReqVoucher.buyerShopContactTel"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("服务信息")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-info" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("紧急状态")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "fl",
                        attrs: { placeholder: "请选择", clearable: true },
                        model: {
                          value: _vm.servcReqVoucher.emgLevel,
                          callback: function($$v) {
                            _vm.$set(_vm.servcReqVoucher, "emgLevel", $$v)
                          },
                          expression: "servcReqVoucher.emgLevel"
                        }
                      },
                      _vm._l(_vm.emgLevelList, function(emgLevel) {
                        return _c("el-option", {
                          key: emgLevel.value,
                          attrs: { label: emgLevel.text, value: emgLevel.value }
                        })
                      })
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("请求描述")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.addRequestDesc },
                        model: {
                          value: _vm.requestDescRedio,
                          callback: function($$v) {
                            _vm.requestDescRedio = $$v
                          },
                          expression: "requestDescRedio"
                        }
                      },
                      [
                        _c("el-radio", {
                          attrs: { label: "情况紧急，需立即解决（默认）" }
                        }),
                        _vm._v(" "),
                        _c("el-radio", {
                          attrs: { label: "按服务约定要求解决" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v(" ")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.requestDesc,
                        callback: function($$v) {
                          _vm.requestDesc = $$v
                        },
                        expression: "requestDesc"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-info" }, [
              _c(
                "div",
                { staticClass: "form-row", staticStyle: { height: "80px" } },
                [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("问题描述")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.troubleDesc,
                          callback: function($$v) {
                            _vm.troubleDesc = $$v
                          },
                          expression: "troubleDesc"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-info" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("响应时长")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c("el-input", {
                      staticClass: "width-1x",
                      model: {
                        value: _vm.servcReqVoucher.yqRspTimeMi,
                        callback: function($$v) {
                          _vm.$set(_vm.servcReqVoucher, "yqRspTimeMi", $$v)
                        },
                        expression: "servcReqVoucher.yqRspTimeMi"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("分钟")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-info" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("要求到达时长")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c("el-input", {
                      staticClass: "width-1x",
                      on: {
                        blur: function($event) {
                          _vm.arriveTimeChange(
                            _vm.servcReqVoucher.yqArriveTimeMi
                          )
                        }
                      },
                      model: {
                        value: _vm.servcReqVoucher.yqArriveTimeMi,
                        callback: function($$v) {
                          _vm.$set(_vm.servcReqVoucher, "yqArriveTimeMi", $$v)
                        },
                        expression: "servcReqVoucher.yqArriveTimeMi"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("分钟")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-info" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("要求完成时长")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c("el-input", {
                      staticClass: "width-1x",
                      model: {
                        value: _vm.servcReqVoucher.yqRepairedTimeMi,
                        callback: function($$v) {
                          _vm.$set(_vm.servcReqVoucher, "yqRepairedTimeMi", $$v)
                        },
                        expression: "servcReqVoucher.yqRepairedTimeMi"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("分钟")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-info" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("预约上门时间")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "planTime" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "请选择预约时间",
                            "picker-options": _vm.pickerOptions,
                            format: "yyyy-MM-dd HH:mm"
                          },
                          model: {
                            value: _vm.servcReqVoucher.planTime,
                            callback: function($$v) {
                              _vm.$set(_vm.servcReqVoucher, "planTime", $$v)
                            },
                            expression: "servcReqVoucher.planTime"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("附件信息")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20" }, [
              _c(
                "div",
                {
                  staticClass: "content required",
                  staticStyle: { "padding-left": "38px" }
                },
                [
                  _c("swb-file-upload", {
                    attrs: {
                      fileGroup: "image-goods",
                      onBeforeUpload: _vm.onBeforeUpload,
                      onProgress: _vm.onProgress,
                      onDone: _vm.onUploadDone,
                      multipleFile: true
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "file-area clearfix" },
                    _vm._l(_vm.servcReqVoucherFileList, function(
                      servcReqVoucherFile,
                      index
                    ) {
                      return _c("swb-file-item", {
                        attrs: {
                          trackKey: index,
                          fileName: servcReqVoucherFile.name,
                          fileUuid: servcReqVoucherFile.fileUuid,
                          fileBrowseUrl: servcReqVoucherFile.fileBrowseUrl,
                          fileDownloadUrl: servcReqVoucherFile.fileDownloadUrl,
                          fileMd5: servcReqVoucherFile.fileMd5,
                          deletable: true,
                          onDelete: _vm.removeUpload
                        }
                      })
                    })
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a20e49e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a20e49e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcReq/ServcReqVoucherSave.vue
// module id = 2098
// module chunks = 1